/* FOLLOWER BOOST V10 — suivi de commande premium via App Proxy (/apps/fb). Aucune clé, aucun secret : Shopify signe la
   requête côté serveur. Accès : client connecté (ses commandes), ou invité par lien sûr (clé de la page de statut Shopify
   ?so=&k=, ou lien signé ?o=&e=&t= des e-mails de suivi). Étapes et progression = données réelles du serveur uniquement. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fb-tracking]');
  if (!root) return;
  var proxy = root.getAttribute('data-proxy') || '/apps/fb';
  var locale = (root.getAttribute('data-locale') || 'fr').slice(0, 2);
  var apiLocale = locale === 'en' ? 'en' : 'fr';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TITLES = {};
  var tTitle = function (l) { return (l.handle && TITLES[l.handle]) || l.title; };
  var L = {
   "fr": {
    "thanks": "Merci pour ta commande !",
    "thanks_text": "Ta commande {n} est bien enregistrée. Suis son avancement ci-dessous.",
    "order": "Commande",
    "service": "Prestation",
    "network": "Réseau",
    "tier": "Formule",
    "quantity": "Quantité",
    "target": "Cible",
    "initial": "Prix initial",
    "discount": "Réduction",
    "total": "Total payé",
    "date": "Date",
    "payment": "Paiement",
    "processing": "Traitement",
    "paid": "Confirmé",
    "pending_pay": "En attente",
    "refunded": "Remboursé",
    "partially_refunded": "Remboursé en partie",
    "delivery": "Livraison",
    "ordered": "Commandé",
    "delivered": "Livré",
    "remaining": "Restant",
    "updated": "Dernière mise à jour",
    "history": "Historique",
    "in_progress": "En cours",
    "copy": "Copier le numéro",
    "copied": "Numéro copié",
    "support": "Contacter le support",
    "my_orders": "Voir mes commandes",
    "shop": "Retour à la boutique",
    "again": "Commander à nouveau",
    "again_note": "Le prix et la disponibilité sont revérifiés au panier.",
    "support_subject": "Sujet",
    "support_message": "Ton message",
    "support_send": "Envoyer",
    "support_sent": "Message envoyé. Notre équipe te répond par e-mail.",
    "empty": "Aucune commande pour le moment.",
    "syncing": "Paiement reçu : ta commande {n} est en cours d’enregistrement. Cette page s’actualise toute seule.",
    "syncing_list": "Si tu viens de payer, ta commande apparaîtra ici dans quelques minutes.",
    "error": "Impossible de charger ta commande pour le moment. Nouvel essai automatique dans un instant.",
    "link_expired": "Ce lien de suivi a expiré. Connecte-toi avec l’e-mail utilisé pour la commande.",
    "link_invalid": "Ce lien de suivi n’est pas valide. Utilise le bouton « Suivre ma commande » de ton e-mail de confirmation, ou connecte-toi avec l’e-mail de la commande.",
    "login": "Se connecter",
    "guest_note": "Accès par lien sécurisé : la cible est partiellement masquée. Connecte-toi avec l’e-mail de la commande pour tout voir.",
    "auto": "Actualisation automatique",
    "no_pct": "La progression s’affiche dès que le fournisseur la communique.",
    "refreshed": "Actualisé à {n}",
    "refresh": "Actualiser",
    "stale": "Mise à jour impossible pour le moment : les informations ci-dessous datent de {n}. Nouvel essai automatique.",
    "offline": "Tu es hors connexion : l’actualisation reprendra dès le retour du réseau.",
    "starts": "Démarrage prévu le {n}, à la fin du délai de rétractation.",
    "login_needed": "Ta session a expiré. Connecte-toi avec l’e-mail utilisé pour la commande.",
    "steps": {
     "received": "Commande reçue",
     "paid": "Paiement confirmé",
     "validated": "Validation de la prestation",
     "sent": "Lancement de la prestation",
     "running": "Livraison en cours",
     "done": "Livraison terminée"
    },
    "ex": {
     "needs_review": [
      "Vérification par notre équipe",
      "Ta commande est vérifiée avant son lancement (la cible par exemple). Tu n’as rien à faire pour l’instant ; si nous avons besoin d’une information, nous t’écrivons."
     ],
     "partial": [
      "Livraison partielle",
      "Une partie a été livrée. La partie manquante est relancée ou remboursée au prorata, selon notre politique de remboursement."
     ],
     "provider_unavailable": [
      "Lancement momentanément retardé",
      "Le lancement sera relancé automatiquement, sans double commande."
     ],
     "incident": [
      "Incident",
      "Un incident bloque la livraison. Notre équipe s’en occupe ; si elle ne peut pas être réalisée, la commande est remboursée."
     ],
     "canceled": [
      "Commande annulée",
      "Cette commande a été annulée."
     ],
     "canceled_refunded": "Cette commande a été annulée et remboursée sur ton moyen de paiement.",
     "canceled_pending": "Cette commande a été annulée. Son remboursement sur ton moyen de paiement est en cours de traitement.",
     "refunded": [
      "Commande remboursée",
      "Le remboursement a été émis sur ton moyen de paiement ; le délai d’affichage dépend de ta banque."
     ]
    }
   },
   "en": {
    "thanks": "Thank you for your order!",
    "thanks_text": "Your order {n} has been recorded. Follow its progress below.",
    "order": "Order",
    "service": "Service",
    "network": "Network",
    "tier": "Option",
    "quantity": "Quantity",
    "target": "Target",
    "initial": "Original price",
    "discount": "Discount",
    "total": "Total paid",
    "date": "Date",
    "payment": "Payment",
    "processing": "Processing",
    "paid": "Confirmed",
    "pending_pay": "Pending",
    "refunded": "Refunded",
    "partially_refunded": "Partly refunded",
    "delivery": "Delivery",
    "ordered": "Ordered",
    "delivered": "Delivered",
    "remaining": "Remaining",
    "updated": "Last update",
    "history": "History",
    "in_progress": "In progress",
    "copy": "Copy order number",
    "copied": "Number copied",
    "support": "Contact support",
    "my_orders": "My orders",
    "shop": "Back to the shop",
    "again": "Buy again",
    "again_note": "Price and availability are checked again in the cart.",
    "support_subject": "Subject",
    "support_message": "Your message",
    "support_send": "Send",
    "support_sent": "Message sent. Our team will reply by e-mail.",
    "empty": "No orders yet.",
    "syncing": "Payment received: your order {n} is being synchronised. This page refreshes automatically.",
    "syncing_list": "If you have just paid, your order will appear here within a few minutes.",
    "error": "We can’t load your order right now. Please try again shortly.",
    "link_expired": "This tracking link has expired. Log in with the e-mail used for the order.",
    "link_invalid": "Invalid tracking link. Log in with the e-mail used for the order.",
    "login": "Log in",
    "guest_note": "Secure-link access: the target is partly hidden. Log in with the order e-mail to see everything.",
    "auto": "Auto-refresh",
    "no_pct": "Progress is shown as soon as the provider reports it.",
    "refreshed": "Updated at {n}",
    "refresh": "Refresh",
    "stale": "Update unavailable right now: the information below is from {n}. Retrying automatically.",
    "offline": "You are offline: updates resume when the connection is back.",
    "starts": "Scheduled to start on {n}, at the end of the withdrawal period.",
    "login_needed": "Your session has expired. Log in with the e-mail used for the order.",
    "steps": {
     "received": "Order received",
     "paid": "Payment confirmed",
     "validated": "Service validated",
     "sent": "Service launched",
     "running": "Delivery in progress",
     "done": "Delivery complete"
    },
    "ex": {
     "needs_review": [
      "Being reviewed by our team",
      "Your order is checked before it starts (for example the target). No action is needed for now."
     ],
     "partial": [
      "Partially delivered",
      "Part of the order was delivered. Our team will contact you."
     ],
     "provider_unavailable": [
      "Provider temporarily unavailable",
      "Sending will be retried automatically, never twice."
     ],
     "incident": [
      "Incident",
      "An incident is blocking delivery. Our team is on it and will keep you posted."
     ],
     "canceled": [
      "Order cancelled",
      "This order was cancelled."
     ],
     "canceled_refunded": "This order was cancelled and refunded to your payment method.",
     "canceled_pending": "This order was cancelled. The refund to your payment method is being processed.",
     "refunded": [
      "Order refunded",
      "The refund has been issued."
     ]
    }
   },
   "es": {
    "thanks": "¡Gracias por tu pedido!",
    "thanks_text": "Tu pedido {n} se ha registrado. Sigue su avance a continuación.",
    "order": "Pedido",
    "service": "Servicio",
    "network": "Red",
    "tier": "Fórmula",
    "quantity": "Cantidad",
    "target": "Objetivo",
    "initial": "Precio inicial",
    "discount": "Descuento",
    "total": "Total pagado",
    "date": "Fecha",
    "payment": "Pago",
    "processing": "Tramitación",
    "paid": "Confirmado",
    "pending_pay": "Pendiente",
    "refunded": "Reembolsado",
    "partially_refunded": "Reembolsado en parte",
    "delivery": "Entrega",
    "ordered": "Pedido",
    "delivered": "Entregado",
    "remaining": "Restante",
    "updated": "Última actualización",
    "history": "Historial",
    "in_progress": "En curso",
    "copy": "Copiar el número",
    "copied": "Número copiado",
    "support": "Contactar con soporte",
    "my_orders": "Ver mis pedidos",
    "shop": "Volver a la tienda",
    "again": "Comprar de nuevo",
    "again_note": "El precio y la disponibilidad se vuelven a comprobar en el carrito.",
    "support_subject": "Asunto",
    "support_message": "Tu mensaje",
    "support_send": "Enviar",
    "support_sent": "Mensaje enviado. Te responderemos por e-mail.",
    "empty": "Aún no hay pedidos.",
    "syncing": "Pago recibido: tu pedido {n} se está sincronizando. Esta página se actualiza sola.",
    "syncing_list": "Si acabas de pagar, tu pedido aparecerá aquí en unos minutos.",
    "error": "No podemos cargar tu pedido ahora. Inténtalo de nuevo en un momento.",
    "link_expired": "Este enlace ha caducado. Inicia sesión con el e-mail del pedido.",
    "link_invalid": "Enlace no válido. Inicia sesión con el e-mail del pedido.",
    "login": "Iniciar sesión",
    "guest_note": "Acceso por enlace seguro: el objetivo está parcialmente oculto.",
    "auto": "Actualización automática",
    "no_pct": "El avance se muestra en cuanto el proveedor lo comunica.",
    "refreshed": "Actualizado a las {n}",
    "refresh": "Actualizar",
    "stale": "No se puede actualizar ahora: la información de abajo es de las {n}. Nuevo intento automático.",
    "offline": "Estás sin conexión: la actualización se reanudará cuando vuelva la red.",
    "starts": "Inicio previsto el {n}, al final del plazo de desistimiento.",
    "login_needed": "Tu sesión ha caducado. Inicia sesión con el e-mail usado para el pedido.",
    "steps": {
     "received": "Pedido recibido",
     "paid": "Pago confirmado",
     "validated": "Validación del servicio",
     "sent": "Enviado al proveedor",
     "running": "Entrega en curso",
     "done": "Entrega completada"
    },
    "ex": {
     "needs_review": [
      "Revisión por nuestro equipo",
      "Revisamos tu pedido antes de iniciarlo. No tienes que hacer nada por ahora."
     ],
     "partial": [
      "Entrega parcial",
      "Se ha entregado una parte. Nuestro equipo te contactará."
     ],
     "provider_unavailable": [
      "Proveedor no disponible",
      "El envío se reintentará automáticamente, nunca dos veces."
     ],
     "incident": [
      "Incidencia",
      "Una incidencia bloquea la entrega. Nuestro equipo se ocupa."
     ],
     "canceled": [
      "Pedido cancelado",
      "Este pedido ha sido cancelado."
     ],
     "canceled_refunded": "Este pedido ha sido cancelado y reembolsado en tu medio de pago.",
     "canceled_pending": "Este pedido ha sido cancelado. El reembolso en tu medio de pago está en curso.",
     "refunded": [
      "Pedido reembolsado",
      "Se ha emitido el reembolso."
     ]
    }
   },
   "de": {
    "thanks": "Danke für deine Bestellung!",
    "thanks_text": "Deine Bestellung {n} wurde erfasst. Den Fortschritt siehst du unten.",
    "order": "Bestellung",
    "service": "Leistung",
    "network": "Netzwerk",
    "tier": "Paket",
    "quantity": "Menge",
    "target": "Ziel",
    "initial": "Ursprünglicher Preis",
    "discount": "Rabatt",
    "total": "Bezahlt",
    "date": "Datum",
    "payment": "Zahlung",
    "processing": "Bearbeitung",
    "paid": "Bestätigt",
    "pending_pay": "Ausstehend",
    "refunded": "Erstattet",
    "partially_refunded": "Teilweise erstattet",
    "delivery": "Lieferung",
    "ordered": "Bestellt",
    "delivered": "Geliefert",
    "remaining": "Verbleibend",
    "updated": "Letzte Aktualisierung",
    "history": "Verlauf",
    "in_progress": "Läuft",
    "copy": "Nummer kopieren",
    "copied": "Nummer kopiert",
    "support": "Support kontaktieren",
    "my_orders": "Meine Bestellungen",
    "shop": "Zurück zum Shop",
    "again": "Erneut kaufen",
    "again_note": "Preis und Verfügbarkeit werden im Warenkorb erneut geprüft.",
    "support_subject": "Betreff",
    "support_message": "Deine Nachricht",
    "support_send": "Senden",
    "support_sent": "Nachricht gesendet. Wir antworten per E-Mail.",
    "empty": "Noch keine Bestellungen.",
    "syncing": "Zahlung erhalten: Bestellung {n} wird synchronisiert. Diese Seite aktualisiert sich automatisch.",
    "syncing_list": "Wenn du gerade bezahlt hast, erscheint deine Bestellung in wenigen Minuten hier.",
    "error": "Deine Bestellung kann gerade nicht geladen werden. Bitte gleich erneut versuchen.",
    "link_expired": "Dieser Link ist abgelaufen. Melde dich mit der E-Mail der Bestellung an.",
    "link_invalid": "Ungültiger Link. Melde dich mit der E-Mail der Bestellung an.",
    "login": "Anmelden",
    "guest_note": "Zugang per sicherem Link: Das Ziel ist teilweise verborgen.",
    "auto": "Automatische Aktualisierung",
    "no_pct": "Der Fortschritt erscheint, sobald der Anbieter ihn meldet.",
    "refreshed": "Aktualisiert um {n}",
    "refresh": "Aktualisieren",
    "stale": "Aktualisierung gerade nicht möglich: Die Angaben unten stammen von {n}. Neuer Versuch erfolgt automatisch.",
    "offline": "Du bist offline: Die Aktualisierung geht weiter, sobald das Netz zurück ist.",
    "starts": "Geplanter Start am {n}, am Ende der Widerrufsfrist.",
    "login_needed": "Deine Sitzung ist abgelaufen. Melde dich mit der E-Mail der Bestellung an.",
    "steps": {
     "received": "Bestellung erhalten",
     "paid": "Zahlung bestätigt",
     "validated": "Leistung geprüft",
     "sent": "An Anbieter übermittelt",
     "running": "Lieferung läuft",
     "done": "Lieferung abgeschlossen"
    },
    "ex": {
     "needs_review": [
      "Prüfung durch unser Team",
      "Deine Bestellung wird vor dem Start geprüft. Du musst gerade nichts tun."
     ],
     "partial": [
      "Teillieferung",
      "Ein Teil wurde geliefert. Unser Team meldet sich."
     ],
     "provider_unavailable": [
      "Anbieter vorübergehend nicht erreichbar",
      "Die Übermittlung wird automatisch wiederholt, nie doppelt."
     ],
     "incident": [
      "Störung",
      "Eine Störung blockiert die Lieferung. Unser Team kümmert sich darum."
     ],
     "canceled": [
      "Bestellung storniert",
      "Diese Bestellung wurde storniert."
     ],
     "canceled_refunded": "Diese Bestellung wurde storniert und auf dein Zahlungsmittel erstattet.",
     "canceled_pending": "Diese Bestellung wurde storniert. Die Erstattung auf dein Zahlungsmittel wird bearbeitet.",
     "refunded": [
      "Bestellung erstattet",
      "Die Erstattung wurde ausgelöst."
     ]
    }
   },
   "it": {
    "thanks": "Grazie per il tuo ordine!",
    "thanks_text": "Il tuo ordine {n} è stato registrato. Segui l’avanzamento qui sotto.",
    "order": "Ordine",
    "service": "Servizio",
    "network": "Rete",
    "tier": "Formula",
    "quantity": "Quantità",
    "target": "Obiettivo",
    "initial": "Prezzo iniziale",
    "discount": "Sconto",
    "total": "Totale pagato",
    "date": "Data",
    "payment": "Pagamento",
    "processing": "Elaborazione",
    "paid": "Confermato",
    "pending_pay": "In attesa",
    "refunded": "Rimborsato",
    "partially_refunded": "Rimborsato in parte",
    "delivery": "Consegna",
    "ordered": "Ordinato",
    "delivered": "Consegnato",
    "remaining": "Restante",
    "updated": "Ultimo aggiornamento",
    "history": "Cronologia",
    "in_progress": "In corso",
    "copy": "Copia il numero",
    "copied": "Numero copiato",
    "support": "Contatta il supporto",
    "my_orders": "I miei ordini",
    "shop": "Torna al negozio",
    "again": "Acquista di nuovo",
    "again_note": "Prezzo e disponibilità vengono ricontrollati nel carrello.",
    "support_subject": "Oggetto",
    "support_message": "Il tuo messaggio",
    "support_send": "Invia",
    "support_sent": "Messaggio inviato. Ti risponderemo via e-mail.",
    "empty": "Ancora nessun ordine.",
    "syncing": "Pagamento ricevuto: l’ordine {n} è in sincronizzazione. La pagina si aggiorna da sola.",
    "syncing_list": "Se hai appena pagato, il tuo ordine apparirà qui tra pochi minuti.",
    "error": "Al momento non riusciamo a caricare il tuo ordine. Riprova tra poco.",
    "link_expired": "Questo link è scaduto. Accedi con l’e-mail dell’ordine.",
    "link_invalid": "Link non valido. Accedi con l’e-mail dell’ordine.",
    "login": "Accedi",
    "guest_note": "Accesso tramite link sicuro: l’obiettivo è in parte nascosto.",
    "auto": "Aggiornamento automatico",
    "no_pct": "L’avanzamento appare non appena il fornitore lo comunica.",
    "refreshed": "Aggiornato alle {n}",
    "refresh": "Aggiorna",
    "stale": "Aggiornamento non disponibile al momento: le informazioni qui sotto risalgono alle {n}. Nuovo tentativo automatico.",
    "offline": "Sei offline: l’aggiornamento riprenderà appena torna la rete.",
    "starts": "Avvio previsto il {n}, alla fine del periodo di recesso.",
    "login_needed": "La tua sessione è scaduta. Accedi con l’e-mail usata per l’ordine.",
    "steps": {
     "received": "Ordine ricevuto",
     "paid": "Pagamento confermato",
     "validated": "Servizio convalidato",
     "sent": "Inviato al fornitore",
     "running": "Consegna in corso",
     "done": "Consegna completata"
    },
    "ex": {
     "needs_review": [
      "Verifica del nostro team",
      "Il tuo ordine viene verificato prima dell’avvio. Per ora non devi fare nulla."
     ],
     "partial": [
      "Consegna parziale",
      "Una parte è stata consegnata. Il nostro team ti contatterà."
     ],
     "provider_unavailable": [
      "Fornitore momentaneamente non disponibile",
      "L’invio verrà ritentato automaticamente, mai due volte."
     ],
     "incident": [
      "Incidente",
      "Un incidente blocca la consegna. Il nostro team se ne occupa."
     ],
     "canceled": [
      "Ordine annullato",
      "Questo ordine è stato annullato."
     ],
     "canceled_refunded": "Questo ordine è stato annullato e rimborsato sul tuo metodo di pagamento.",
     "canceled_pending": "Questo ordine è stato annullato. Il rimborso sul tuo metodo di pagamento è in corso.",
     "refunded": [
      "Ordine rimborsato",
      "Il rimborso è stato emesso."
     ]
    }
   },
   "nl": {
    "thanks": "Bedankt voor je bestelling!",
    "thanks_text": "Je bestelling {n} is geregistreerd. Volg hieronder de voortgang.",
    "order": "Bestelling",
    "service": "Dienst",
    "network": "Netwerk",
    "tier": "Pakket",
    "quantity": "Aantal",
    "target": "Doel",
    "initial": "Oorspronkelijke prijs",
    "discount": "Korting",
    "total": "Totaal betaald",
    "date": "Datum",
    "payment": "Betaling",
    "processing": "In behandeling",
    "paid": "Bevestigd",
    "pending_pay": "In afwachting",
    "refunded": "Terugbetaald",
    "partially_refunded": "Gedeeltelijk terugbetaald",
    "delivery": "Levering",
    "ordered": "Besteld",
    "delivered": "Geleverd",
    "remaining": "Resterend",
    "updated": "Laatste update",
    "history": "Geschiedenis",
    "in_progress": "Bezig",
    "copy": "Nummer kopiëren",
    "copied": "Nummer gekopieerd",
    "support": "Contact opnemen met support",
    "my_orders": "Mijn bestellingen bekijken",
    "shop": "Terug naar de winkel",
    "again": "Opnieuw bestellen",
    "again_note": "Prijs en beschikbaarheid worden in de winkelwagen opnieuw gecontroleerd.",
    "support_subject": "Onderwerp",
    "support_message": "Je bericht",
    "support_send": "Versturen",
    "support_sent": "Bericht verstuurd. Ons team antwoordt je per e-mail.",
    "empty": "Nog geen bestellingen.",
    "syncing": "Betaling ontvangen: je bestelling {n} wordt geregistreerd. Deze pagina wordt automatisch vernieuwd.",
    "syncing_list": "Heb je net betaald? Dan verschijnt je bestelling hier binnen enkele minuten.",
    "error": "Je bestelling kan nu niet worden geladen. Zo meteen volgt automatisch een nieuwe poging.",
    "link_expired": "Deze trackinglink is verlopen. Log in met het e-mailadres dat je voor de bestelling hebt gebruikt.",
    "link_invalid": "Deze trackinglink is ongeldig. Gebruik de knop ‘Mijn bestelling volgen’ in je bevestigingsmail, of log in met het e-mailadres van de bestelling.",
    "login": "Inloggen",
    "guest_note": "Toegang via beveiligde link: het doel is gedeeltelijk verborgen. Log in met het e-mailadres van de bestelling om alles te zien.",
    "auto": "Automatisch vernieuwen",
    "no_pct": "De voortgang wordt getoond zodra de leverancier die doorgeeft.",
    "refreshed": "Vernieuwd om {n}",
    "refresh": "Vernieuwen",
    "stale": "Bijwerken lukt nu niet: de informatie hieronder is van {n}. Er volgt automatisch een nieuwe poging.",
    "offline": "Je bent offline: het vernieuwen gaat verder zodra je weer verbinding hebt.",
    "starts": "Start gepland op {n}, aan het einde van de herroepingstermijn.",
    "login_needed": "Je sessie is verlopen. Log in met het e-mailadres dat je voor de bestelling hebt gebruikt.",
    "steps": {
     "received": "Bestelling ontvangen",
     "paid": "Betaling bevestigd",
     "validated": "Validatie van de dienst",
     "sent": "Start van de dienst",
     "running": "Levering bezig",
     "done": "Levering voltooid"
    },
    "ex": {
     "needs_review": [
      "Controle door ons team",
      "Je bestelling wordt gecontroleerd voordat ze start (bijvoorbeeld het doel). Je hoeft nu niets te doen; als we informatie nodig hebben, sturen we je een bericht."
     ],
     "partial": [
      "Gedeeltelijke levering",
      "Een deel is geleverd. Het ontbrekende deel wordt opnieuw gestart of naar rato terugbetaald, volgens ons terugbetalingsbeleid."
     ],
     "provider_unavailable": [
      "Start tijdelijk vertraagd",
      "De start wordt automatisch opnieuw geprobeerd, zonder dubbele bestelling."
     ],
     "incident": [
      "Incident",
      "Een incident blokkeert de levering. Ons team pakt het op; als de levering niet kan worden uitgevoerd, wordt de bestelling terugbetaald."
     ],
     "canceled": [
      "Bestelling geannuleerd",
      "Deze bestelling is geannuleerd."
     ],
     "canceled_refunded": "Deze bestelling is geannuleerd en terugbetaald via je betaalmethode.",
     "canceled_pending": "Deze bestelling is geannuleerd. De terugbetaling via je betaalmethode wordt verwerkt.",
     "refunded": [
      "Bestelling terugbetaald",
      "De terugbetaling naar je betaalmethode is uitgevoerd; hoe snel die zichtbaar is, hangt af van je bank."
     ]
    }
   },
   "pt": {
    "thanks": "Obrigado pela tua encomenda!",
    "thanks_text": "A tua encomenda {n} foi registada. Acompanha o progresso abaixo.",
    "order": "Encomenda",
    "service": "Serviço",
    "network": "Rede",
    "tier": "Pacote",
    "quantity": "Quantidade",
    "target": "Alvo",
    "initial": "Preço inicial",
    "discount": "Desconto",
    "total": "Total pago",
    "date": "Data",
    "payment": "Pagamento",
    "processing": "Em processamento",
    "paid": "Confirmado",
    "pending_pay": "Pendente",
    "refunded": "Reembolsado",
    "partially_refunded": "Parcialmente reembolsado",
    "delivery": "Entrega",
    "ordered": "Encomendado",
    "delivered": "Entregue",
    "remaining": "Restante",
    "updated": "Última atualização",
    "history": "Histórico",
    "in_progress": "Em curso",
    "copy": "Copiar o número",
    "copied": "Número copiado",
    "support": "Contactar o apoio ao cliente",
    "my_orders": "Ver as minhas encomendas",
    "shop": "Voltar à loja",
    "again": "Encomendar novamente",
    "again_note": "O preço e a disponibilidade são verificados novamente no carrinho.",
    "support_subject": "Assunto",
    "support_message": "A tua mensagem",
    "support_send": "Enviar",
    "support_sent": "Mensagem enviada. A nossa equipa responde-te por e-mail.",
    "empty": "Ainda não há encomendas.",
    "syncing": "Pagamento recebido: a tua encomenda {n} está a ser registada. Esta página atualiza-se sozinha.",
    "syncing_list": "Se acabaste de pagar, a tua encomenda vai aparecer aqui dentro de alguns minutos.",
    "error": "Não é possível carregar a tua encomenda de momento. Nova tentativa automática dentro de instantes.",
    "link_expired": "Esta ligação de acompanhamento expirou. Inicia sessão com o e-mail usado na encomenda.",
    "link_invalid": "Esta ligação de acompanhamento não é válida. Usa o botão «Acompanhar a minha encomenda» do teu e-mail de confirmação, ou inicia sessão com o e-mail da encomenda.",
    "login": "Iniciar sessão",
    "guest_note": "Acesso por ligação segura: o alvo está parcialmente oculto. Inicia sessão com o e-mail da encomenda para veres tudo.",
    "auto": "Atualização automática",
    "no_pct": "O progresso aparece assim que o fornecedor o comunicar.",
    "refreshed": "Atualizado às {n}",
    "refresh": "Atualizar",
    "stale": "Não é possível atualizar de momento: as informações abaixo são de {n}. Nova tentativa automática.",
    "offline": "Estás sem ligação: a atualização será retomada assim que a rede voltar.",
    "starts": "Início previsto a {n}, no fim do prazo de livre resolução.",
    "login_needed": "A tua sessão expirou. Inicia sessão com o e-mail usado na encomenda.",
    "steps": {
     "received": "Encomenda recebida",
     "paid": "Pagamento confirmado",
     "validated": "Validação do serviço",
     "sent": "Início do serviço",
     "running": "Entrega em curso",
     "done": "Entrega concluída"
    },
    "ex": {
     "needs_review": [
      "Verificação pela nossa equipa",
      "A tua encomenda é verificada antes de começar (o alvo, por exemplo). Para já não tens de fazer nada; se precisarmos de alguma informação, escrevemos-te."
     ],
     "partial": [
      "Entrega parcial",
      "Uma parte foi entregue. A parte em falta é relançada ou reembolsada proporcionalmente, de acordo com a nossa política de reembolso."
     ],
     "provider_unavailable": [
      "Início temporariamente adiado",
      "O início será retomado automaticamente, sem encomenda duplicada."
     ],
     "incident": [
      "Incidente",
      "Um incidente está a bloquear a entrega. A nossa equipa está a tratar disso; se não for possível realizá-la, a encomenda é reembolsada."
     ],
     "canceled": [
      "Encomenda cancelada",
      "Esta encomenda foi cancelada."
     ],
     "canceled_refunded": "Esta encomenda foi cancelada e reembolsada no teu meio de pagamento.",
     "canceled_pending": "Esta encomenda foi cancelada. O reembolso no teu meio de pagamento está a ser processado.",
     "refunded": [
      "Encomenda reembolsada",
      "O reembolso foi emitido para o teu meio de pagamento; o prazo até aparecer depende do teu banco."
     ]
    }
   },
   "pl": {
    "thanks": "Dziękujemy za zamówienie!",
    "thanks_text": "Twoje zamówienie {n} zostało zarejestrowane. Śledź jego postęp poniżej.",
    "order": "Zamówienie",
    "service": "Usługa",
    "network": "Sieć",
    "tier": "Pakiet",
    "quantity": "Ilość",
    "target": "Cel",
    "initial": "Cena pierwotna",
    "discount": "Rabat",
    "total": "Łącznie zapłacono",
    "date": "Data",
    "payment": "Płatność",
    "processing": "Przetwarzanie",
    "paid": "Potwierdzono",
    "pending_pay": "Oczekuje",
    "refunded": "Zwrócono",
    "partially_refunded": "Zwrócono częściowo",
    "delivery": "Dostawa",
    "ordered": "Zamówiono",
    "delivered": "Dostarczono",
    "remaining": "Pozostało",
    "updated": "Ostatnia aktualizacja",
    "history": "Historia",
    "in_progress": "W toku",
    "copy": "Kopiuj numer",
    "copied": "Numer skopiowany",
    "support": "Skontaktuj się z pomocą",
    "my_orders": "Zobacz moje zamówienia",
    "shop": "Wróć do sklepu",
    "again": "Zamów ponownie",
    "again_note": "Cena i dostępność zostaną ponownie sprawdzone w koszyku.",
    "support_subject": "Temat",
    "support_message": "Twoja wiadomość",
    "support_send": "Wyślij",
    "support_sent": "Wiadomość wysłana. Nasz zespół odpowie ci e-mailem.",
    "empty": "Na razie brak zamówień.",
    "syncing": "Płatność otrzymana: twoje zamówienie {n} jest właśnie rejestrowane. Ta strona odświeży się sama.",
    "syncing_list": "Jeśli płatność została właśnie dokonana, twoje zamówienie pojawi się tutaj w ciągu kilku minut.",
    "error": "Nie można teraz wczytać twojego zamówienia. Za chwilę nastąpi automatyczna ponowna próba.",
    "link_expired": "Ten link do śledzenia wygasł. Zaloguj się adresem e-mail użytym przy zamówieniu.",
    "link_invalid": "Ten link do śledzenia jest nieprawidłowy. Użyj przycisku „Śledź moje zamówienie” w e-mailu z potwierdzeniem albo zaloguj się adresem e-mail z zamówienia.",
    "login": "Zaloguj się",
    "guest_note": "Dostęp przez bezpieczny link: cel jest częściowo ukryty. Zaloguj się adresem e-mail z zamówienia, aby zobaczyć wszystko.",
    "auto": "Automatyczne odświeżanie",
    "no_pct": "Postęp pojawi się, gdy tylko dostawca go przekaże.",
    "refreshed": "Odświeżono o {n}",
    "refresh": "Odśwież",
    "stale": "Aktualizacja jest teraz niemożliwa: poniższe informacje pochodzą z {n}. Automatyczna ponowna próba.",
    "offline": "Jesteś offline: odświeżanie zostanie wznowione po przywróceniu połączenia.",
    "starts": "Planowane rozpoczęcie: {n}, po upływie terminu na odstąpienie od umowy.",
    "login_needed": "Twoja sesja wygasła. Zaloguj się adresem e-mail użytym przy zamówieniu.",
    "steps": {
     "received": "Zamówienie przyjęte",
     "paid": "Płatność potwierdzona",
     "validated": "Zatwierdzenie usługi",
     "sent": "Uruchomienie usługi",
     "running": "Dostawa w toku",
     "done": "Dostawa zakończona"
    },
    "ex": {
     "needs_review": [
      "Weryfikacja przez nasz zespół",
      "Twoje zamówienie jest sprawdzane przed uruchomieniem (np. cel). Na razie nie musisz nic robić; jeśli będziemy potrzebować informacji, napiszemy do ciebie."
     ],
     "partial": [
      "Częściowa dostawa",
      "Część została dostarczona. Brakująca część zostanie uruchomiona ponownie lub proporcjonalnie zwrócona zgodnie z naszą polityką zwrotów."
     ],
     "provider_unavailable": [
      "Uruchomienie chwilowo opóźnione",
      "Uruchomienie zostanie automatycznie ponowione, bez podwójnego zamówienia."
     ],
     "incident": [
      "Incydent",
      "Incydent blokuje dostawę. Nasz zespół się tym zajmuje; jeśli nie da się jej zrealizować, otrzymasz zwrot za zamówienie."
     ],
     "canceled": [
      "Zamówienie anulowane",
      "To zamówienie zostało anulowane."
     ],
     "canceled_refunded": "To zamówienie zostało anulowane, a środki zwrócone na twoją metodę płatności.",
     "canceled_pending": "To zamówienie zostało anulowane. Zwrot środków na twoją metodę płatności jest w trakcie realizacji.",
     "refunded": [
      "Zwrócono środki za zamówienie",
      "Zwrot został zlecony na twoją metodę płatności; czas jego zaksięgowania zależy od twojego banku."
     ]
    }
   }
  };
  if (window.FB_TRACKING_L10N) Object.keys(window.FB_TRACKING_L10N).forEach(function (k) { L[k] = window.FB_TRACKING_L10N[k]; });
  var T = L[locale] || (locale === 'fr' ? L.fr : L.en);
  var status = {}; try { status = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}
  var NET = { instagram: 'Instagram', tiktok: 'TikTok', youtube: 'YouTube', facebook: 'Facebook', x: 'X', telegram: 'Telegram', whatsapp: 'WhatsApp', snapchat: 'Snapchat', spotify: 'Spotify', twitch: 'Twitch', linkedin: 'LinkedIn', discord: 'Discord', vimeo: 'Vimeo' };
  var intl = { en: 'en-GB', es: 'es-ES', de: 'de-DE', it: 'it-IT', nl: 'nl-NL', pt: 'pt-PT', pl: 'pl-PL', sv: 'sv-SE', da: 'da-DK', nb: 'nb-NO', fi: 'fi-FI', cs: 'cs-CZ', sk: 'sk-SK', hu: 'hu-HU', ro: 'ro-RO', el: 'el-GR', bg: 'bg-BG', sl: 'sl-SI', lt: 'lt-LT' }[locale] || 'fr-FR';
  var fmtDate = function (iso) { try { return new Date(iso).toLocaleString(intl, { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) { return iso || ''; } };
  var money = function (v, cur) { try { return new Intl.NumberFormat(intl, { style: 'currency', currency: cur || 'EUR' }).format(v); } catch (e) { return v + ' ' + (cur || ''); } };
  var num = function (v) { return v == null ? '—' : Number(v).toLocaleString(intl); };
  var fill = function (s, n) { return String(s).replace('{n}', n); };
  /* Construction DOM sûre (textContent uniquement) */
  function h(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function row(dl, k, v, strong) { dl.appendChild(h('dt', null, k)); var dd = h('dd', strong ? 'is-strong' : null, v); dl.appendChild(dd); return dd; }
  var ICON = { done: 'M5 12.5l4.2 4.2L19 7', current: '', todo: '' };
  function check() { var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true'); var p = document.createElementNS('http://www.w3.org/2000/svg', 'path'); p.setAttribute('d', ICON.done); s.appendChild(p); return s; }

  function steps(l) {
    var ol = h('ol', 'fbt-steps');
    var stopped = l.statusKey === 'canceled' || l.statusKey === 'refunded'; // commande arrêtée : aucune étape « en cours »
    (l.steps || []).forEach(function (s) {
      var li = h('li', 'fbt-step is-' + (stopped && s.state === 'current' ? 'todo' : s.state)); var dot = h('span', 'fbt-step__dot'); if (s.state === 'done') dot.appendChild(check());
      li.appendChild(dot); var tx = h('span', 'fbt-step__text'); tx.appendChild(h('b', null, T.steps[s.key] || s.key)); if (s.at) tx.appendChild(h('small', null, fmtDate(s.at)));
      li.appendChild(tx); ol.appendChild(li);
    });
    return ol;
  }
  function line(o, l, guest) {
    var c = h('section', 'fbt-line');
    var head = h('div', 'fbt-line__head'); var lt = h('h3', 'fbt-line__title', tTitle(l)); if (l.handle) lt.setAttribute('data-fbt-handle', l.handle); head.appendChild(lt);
    var chip = h('span', 'fbt-chip fbt-chip--' + l.statusKey, status[l.statusKey] || l.statusLabel); head.appendChild(chip); c.appendChild(head);
    if (l.exception && T.ex[l.exception]) {
      // Annulée mais remboursement pas encore enregistré dans Shopify : on le dit, sans prétendre qu'il est émis.
      var exText = T.ex[l.exception][1];
      if (l.exception === 'canceled' && o.financialStatus === 'paid' && T.ex.canceled_pending) exText = T.ex.canceled_pending;
      else if (l.exception === 'canceled' && /refunded/.test(o.financialStatus || '') && T.ex.canceled_refunded) exText = T.ex.canceled_refunded;
      var ex = h('div', 'fbt-alert fbt-alert--' + l.exception); ex.setAttribute('role', 'status'); ex.appendChild(h('b', null, T.ex[l.exception][0])); ex.appendChild(h('span', null, exText)); c.appendChild(ex);
    }
    c.appendChild(steps(l));
    // Progression : uniquement si le fournisseur a communiqué des quantités réelles
    var box = h('div', 'fbt-progress');
    if (typeof l.progress === 'number') {
      var bar = h('div', 'fbt-bar'); var fillEl = h('i'); fillEl.style.width = l.progress + '%'; bar.appendChild(fillEl); bar.setAttribute('role', 'progressbar'); bar.setAttribute('aria-valuenow', String(l.progress)); bar.setAttribute('aria-valuemin', '0'); bar.setAttribute('aria-valuemax', '100');
      var top = h('div', 'fbt-progress__top'); top.appendChild(h('span', null, T.delivery)); top.appendChild(h('b', null, l.progress + ' %')); box.appendChild(top); box.appendChild(bar);
    } else if (l.startsAt) {
      box.appendChild(h('p', 'fbt-muted', fill(T.starts || L.fr.starts, fmtDate(l.startsAt))));
    } else if (l.statusKey === 'processing' || l.statusKey === 'validating' || l.statusKey === 'pending') {
      box.appendChild(h('p', 'fbt-muted', T.in_progress + ' — ' + T.no_pct));
    }
    var dl = h('dl', 'fbt-dl');
    row(dl, T.network, NET[l.platform] || l.platform || '—'); if (l.tierLabel) row(dl, T.tier, l.tierLabel);
    row(dl, T.target, l.target || '—'); row(dl, T.ordered, num(l.quantity));
    if (l.delivered != null) row(dl, T.delivered, num(l.delivered)); if (l.remaining != null) row(dl, T.remaining, num(l.remaining));
    row(dl, T.updated, fmtDate(l.updatedAt));
    box.appendChild(dl); c.appendChild(box);
    if ((l.timeline || []).length) {
      var det = h('details', 'fbt-history'); det.setAttribute('data-k', 'h' + l.id); det.appendChild(h('summary', null, T.history)); var ul = h('ul');
      l.timeline.slice().reverse().forEach(function (ev) { ul.appendChild(h('li', null, (status[ev.statusKey] || ev.label) + ' · ' + fmtDate(ev.at))); });
      det.appendChild(ul); c.appendChild(det);
    }
    if (l.handle) { var again = h('a', 'fbt-btn fbt-btn--ghost', T.again); again.href = ROOT + 'products/' + encodeURIComponent(l.handle); again.title = T.again_note; c.appendChild(again); }
    return c;
  }
  function payLabel(o) { return o.financialStatus === 'paid' ? T.paid : o.financialStatus === 'refunded' ? T.refunded : o.financialStatus === 'partially_refunded' ? T.partially_refunded : T.pending_pay; }
  function order(o, opts) {
    var card = h('article', 'fbt-order');
    if (opts.single && o.paid && o.statusKey !== 'canceled' && o.statusKey !== 'refunded') {
      var hero = h('div', 'fbt-thanks'); var ic = h('span', 'fbt-thanks__icon'); ic.appendChild(check()); hero.appendChild(ic);
      hero.appendChild(h('h2', null, T.thanks)); hero.appendChild(h('p', null, fill(T.thanks_text, o.name))); card.appendChild(hero);
    }
    var head = h('header', 'fbt-order__head');
    var nm = h('div', 'fbt-order__name'); nm.appendChild(h('span', 'fbt-eyebrow', T.order)); nm.appendChild(h('strong', null, o.name)); head.appendChild(nm);
    var cp = h('button', 'fbt-icon-btn', T.copy); cp.type = 'button';
    cp.addEventListener('click', function () { var done = function () { cp.textContent = T.copied; setTimeout(function () { cp.textContent = T.copy; }, 1800); }; if (navigator.clipboard) navigator.clipboard.writeText(o.name).then(done, done); else done(); });
    head.appendChild(cp); card.appendChild(head);
    var sum = h('dl', 'fbt-dl fbt-summary');
    var first = (o.lines || [])[0];
    if (first && o.lines.length === 1) { var sd = row(sum, T.service, tTitle(first)); if (first.handle) sd.setAttribute('data-fbt-handle', first.handle); row(sum, T.quantity, num(first.quantity)); }
    if (o.subtotal != null && o.discount > 0) { row(sum, T.initial, money(o.subtotal, o.currency)); row(sum, T.discount, '−' + money(o.discount, o.currency)); }
    row(sum, T.total, money(o.total, o.currency), true);
    row(sum, T.date, fmtDate(o.createdAt));
    row(sum, T.payment, payLabel(o)); row(sum, T.processing, status[o.statusKey] || o.statusLabel);
    card.appendChild(sum);
    (o.lines || []).forEach(function (l) { card.appendChild(line(o, l, opts.guest)); });
    var act = h('div', 'fbt-actions');
    var sup = h(opts.guest ? 'a' : 'button', 'fbt-btn fbt-btn--primary', T.support);
    if (opts.guest) sup.href = '/pages/contact?order=' + encodeURIComponent(o.name); else { sup.type = 'button'; sup.addEventListener('click', function () { supportForm(o, act); }); }
    act.appendChild(sup);
    var mine = h('a', 'fbt-btn fbt-btn--ghost', T.my_orders); mine.href = root.getAttribute('data-account') || '/account'; act.appendChild(mine);
    var shop = h('a', 'fbt-btn fbt-btn--ghost', T.shop); shop.href = '/'; act.appendChild(shop);
    card.appendChild(act);
    if (opts.guest) card.appendChild(h('p', 'fbt-muted fbt-note', T.guest_note));
    return card;
  }
  function supportForm(o, after) {
    if (after.nextElementSibling && after.nextElementSibling.matches('form')) return;
    var f = h('form', 'fbt-support'); var s1 = h('label', null, T.support_subject); var i1 = h('input'); i1.name = 'subject'; i1.required = true; i1.maxLength = 200; i1.value = T.order + ' ' + o.name; s1.appendChild(i1);
    var s2 = h('label', null, T.support_message); var i2 = h('textarea'); i2.name = 'message'; i2.required = true; i2.maxLength = 4000; i2.rows = 4; s2.appendChild(i2);
    var b = h('button', 'fbt-btn fbt-btn--primary', T.support_send); b.type = 'submit'; var m = h('p', 'fbt-muted'); m.hidden = true;
    f.appendChild(s1); f.appendChild(s2); f.appendChild(b); f.appendChild(m);
    f.addEventListener('submit', function (e) { e.preventDefault(); b.disabled = true;
      fetch(proxy + '/me/support', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ orderId: o.id, subject: i1.value, message: i2.value }) })
        .then(function (r) { m.hidden = false; m.textContent = r.ok ? T.support_sent : T.error; if (!r.ok) b.disabled = false; })
        .catch(function () { m.hidden = false; m.textContent = T.error; b.disabled = false; }); });
    after.after(f);
  }
  var TERMINAL = { completed: 1, canceled: 1, refunded: 1 };
  var POLL = 60000, MAX_POLL = 300000;
  var timer = null, lastJson = '', lastOk = 0, failures = 0, loader = null, rendered = false;
  var t = function (k) { return T[k] || L.fr[k] || ''; };
  var hhmm = function (d) { try { return d.toLocaleTimeString(intl, { hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } };
  function isLive(data) { return !data || (Array.isArray(data) ? data : (data.orders || [data])).some(function (o) { return !TERMINAL[o.statusKey]; }); }
  function next(ms) { clearTimeout(timer); if (!document.hidden && loader) timer = setTimeout(loader, ms); }
  function schedule(data) { failures = 0; if (isLive(data)) next(POLL); else clearTimeout(timer); }
  function retryLater() { failures++; next(Math.min(MAX_POLL, POLL * Math.pow(2, failures - 1))); }
  // Barre d'état : heure de la dernière actualisation + bouton « Actualiser » ; avertissement non bloquant en cas d'échec.
  function bar(state) {
    var b = root.querySelector('.fbt-live'); if (!b) return;
    var tx = b.querySelector('span'); tx.className = state === 'ok' ? '' : 'is-warn';
    tx.textContent = state === 'ok' ? fill(t('refreshed'), hhmm(new Date(lastOk))) : state === 'offline' ? t('offline') : fill(t('stale'), hhmm(new Date(lastOk)));
  }
  function liveBar() {
    var b = h('div', 'fbt-live'); b.setAttribute('aria-live', 'polite'); b.appendChild(h('span'));
    var btn = h('button', 'fbt-icon-btn', t('refresh')); btn.type = 'button'; btn.addEventListener('click', function () { if (loader) { clearTimeout(timer); loader(); } });
    b.appendChild(btn); return b;
  }
  // Rendu : rien n'est redessiné si les données n'ont pas changé ; sinon l'état ouvert de l'historique et du formulaire est conservé.
  function render(data, build) {
    var json = JSON.stringify(data); lastOk = Date.now();
    if (json === lastJson && rendered) { bar('ok'); return; }
    var open = {}; root.querySelectorAll('details[open][data-k]').forEach(function (d) { open[d.getAttribute('data-k')] = 1; });
    if (root.querySelector('.fbt-support textarea') && root.querySelector('.fbt-support textarea').value) { bar('ok'); return; } // ne jamais effacer un message en cours de saisie
    var nodes = build(); root.hidden = false; root.innerHTML = ''; if (rendered) root.classList.add('is-refresh');
    nodes.forEach(function (n) { root.appendChild(n); }); root.appendChild(liveBar());
    root.querySelectorAll('details[data-k]').forEach(function (d) { if (open[d.getAttribute('data-k')]) d.open = true; });
    lastJson = json; rendered = true; bar('ok'); localizeTitles();
  }
  // V11 — nom des prestations dans la langue de la boutique (affichage seul : la commande garde son titre d'origine).
  function localizeTitles() {
    if (locale === 'fr') return;
    root.querySelectorAll('[data-fbt-handle]').forEach(function (el) {
      var hd = el.getAttribute('data-fbt-handle');
      if (TITLES[hd]) { el.textContent = TITLES[hd]; return; }
      if (TITLES[hd] === false) return;
      TITLES[hd] = false;
      fetch(ROOT + 'products/' + encodeURIComponent(hd) + '.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p && p.title) { TITLES[hd] = p.title; root.querySelectorAll('[data-fbt-handle="' + hd + '"]').forEach(function (e) { e.textContent = p.title; }); } })
        .catch(function () {});
    });
  }
  function show(nodes) { root.hidden = false; root.innerHTML = ''; nodes.forEach(function (n) { root.appendChild(n); }); }
  function msg(text, withLogin) { var p = h('p', 'fbt-muted', text); p.setAttribute('role', 'alert'); var out = [p]; if (withLogin) { var a = h('a', 'fbt-btn fbt-btn--primary', T.login); a.href = root.getAttribute('data-login') || '/account/login'; out.push(a); } show(out); rendered = false; lastJson = ''; }
  // Échec passager (réseau, 429, 5xx) : la dernière version affichée reste visible ; sinon message et nouvel essai.
  function softFail() { if (rendered) { bar(navigator.onLine === false ? 'offline' : 'stale'); } else { msg(t('error')); } retryLater(); }
  function get(path) {
    var ctl = window.AbortController ? new AbortController() : null; var to = ctl ? setTimeout(function () { ctl.abort(); }, 20000) : 0;
    return fetch(proxy + path, { credentials: 'same-origin', headers: { accept: 'application/json' }, cache: 'no-store', signal: ctl ? ctl.signal : undefined }).finally(function () { clearTimeout(to); });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearTimeout(timer); return; }
    if (loader && (!lastOk || Date.now() - lastOk > 30000) && (isLive(lastJson ? JSON.parse(lastJson) : null) || !rendered)) loader();
  });
  window.addEventListener('online', function () { if (loader) { clearTimeout(timer); loader(); } });
  window.addEventListener('offline', function () { if (rendered) bar('offline'); });

  var mode = root.getAttribute('data-mode') || 'member';
  var qs = new URLSearchParams(location.search);
  var keyLink = qs.get('so') && qs.get('k');
  var signed = qs.get('o') && qs.get('e') && qs.get('t');
  if (keyLink || signed) {
    // Invité (ou client connecté arrivant d'un lien) : une seule commande. Le numéro seul n'ouvre rien (contrôle serveur).
    var login = document.querySelector('[data-fb-login]'); if (login) login.hidden = true;
    var params = keyLink ? { so: qs.get('so'), k: qs.get('k') } : { o: qs.get('o'), e: qs.get('e'), t: qs.get('t') };
    params.locale = apiLocale;
    var loadOne = function () {
      get('/track?' + new URLSearchParams(params)).then(function (r) {
        if (r.status === 410) throw new Error('expired'); if (r.status === 403 || r.status === 401) throw new Error('invalid'); if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }).then(function (d) {
        if (d.syncing) { if (!rendered) msg(fill(T.syncing, d.name || '')); clearTimeout(timer); timer = setTimeout(loadOne, 15000); return; }
        render(d.order, function () { return [order(d.order, { single: true, guest: true })]; }); schedule(d.order);
      }).catch(function (e) {
        if (e.message === 'expired' || e.message === 'invalid') { clearTimeout(timer); msg(e.message === 'expired' ? T.link_expired : T.link_invalid, true); return; }
        softFail();
      });
    };
    loader = loadOne;
    loadOne();
    return;
  }
  if (mode !== 'member') return;
  var loadMine = function () {
    get('/me/orders?locale=' + apiLocale).then(function (r) {
      if (r.status === 401 || r.status === 403) throw new Error('auth'); if (!r.ok) throw new Error(String(r.status)); return r.json();
    }).then(function (d) {
        if (!d.orders || !d.orders.length) { show([h('p', 'fbt-muted', T.empty), h('p', 'fbt-muted', T.syncing_list)]); rendered = false; lastOk = Date.now(); next(30000); return; }
        var want = (qs.get('order') || '').replace(/^#?/, '#');
        var list = want.length > 1 ? d.orders.filter(function (o) { return o.name === want; }) : d.orders;
        if (!list.length) list = d.orders;
        render(list, function () { return list.map(function (o, i) { return order(o, { single: list.length === 1 || (i === 0 && !!qs.get('order')), guest: false }); }); });
        schedule({ orders: list });
      }).catch(function (e) { if (e.message === 'auth') { clearTimeout(timer); msg(t('login_needed'), true); return; } softFail(); });
  };
  loader = loadMine;
  loadMine();
})();
